import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { SELECTED_SCREEN, SUB_SCREEN } from "../../constants/UploadFilesConstants";

import CameraView from "./CameraView/CameraView";
import MarkupFiles from "./MarkupFiles/MarkupFiles";
import SelectFiles from "./SelectFiles/SelectFiles";
import UploadFilesLoader from "./UploadFilesLoader";
import UploadedFiles from "./UploadedFiles/UploadedFiles";
import { DISABLE, ENABLED } from "../../constants/Constants";
import { changeUploadFileScreen, changeUploadFileSubScreen } from "../../reducers/uploadFile-reducer";

const UploadFiles = ({ dispatchJoinMeeting }) => {
    const dispatch = useDispatch();

    const { screenToShow, subScreenToShow } = useSelector((state) => state.uploadFile);
    const { joinMeetingData } = useSelector((state) => state.joinMeeting);

    const [selectedFiles, setSelectedFiles] = useState([]);

    const updatedSelectedFiles = (files) => {
        setSelectedFiles(files);
    };

    useEffect(() => {
        if (joinMeetingData) {
            // Handle Only Upload file flow
            const featureFlag = joinMeetingData?.sessionConfigurations;
            if (featureFlag?.LIVEVIDEO === DISABLE && featureFlag?.ENABLESCREENSHARE === DISABLE && featureFlag?.UPLOADFILE === ENABLED) {
                dispatch(changeUploadFileScreen(SELECTED_SCREEN.SELECT_FILES));
                dispatch(changeUploadFileSubScreen(SUB_SCREEN.OFF_VIEW));
            }
        }
    }, [joinMeetingData]);

    return (
        <div className='upload-files' data-testid='upload-file'>
            {screenToShow === SELECTED_SCREEN.SELECT_FILES && (
                <SelectFiles updatedSelectedFiles={updatedSelectedFiles} dispatchJoinMeeting={dispatchJoinMeeting} />
            )}
            {screenToShow === SELECTED_SCREEN.MARKUP && <MarkupFiles updatedSelectedFiles={updatedSelectedFiles} />}
            {screenToShow === SELECTED_SCREEN.FINAL_UPLODING_VIEW && (
                <UploadedFiles updatedSelectedFiles={updatedSelectedFiles} dispatchJoinMeeting={dispatchJoinMeeting} />
            )}
            {subScreenToShow === SUB_SCREEN.MARKUP_LOADING_IMAGE && <UploadFilesLoader selectedFiles={selectedFiles} />}
            {subScreenToShow === SUB_SCREEN.CAMERA_VIEW && <CameraView updatedSelectedFiles={updatedSelectedFiles} />}
        </div>
    );
};

export default UploadFiles;
